import { createReducer, Action, on } from '@ngrx/store';

import * as fromActions from './delivery-sort.actions';

export type DeliverySortField =
  | ''
  | 'artistName'
  | 'deliveryDate'
  | 'releaseDate'
  | 'businessLabelName'
  | 'sentBy';
export type DeliverySortType = '' | 'unread' | 'asc' | 'desc';
export type DeliverySortView = 'All' | 'unread';

export interface DeliverySort {
  fieldName: DeliverySortField;
  sortType: '' | 'unread' | 'asc' | 'desc';
  viewBy?: 'All' | 'unread';
}

export const initialState: DeliverySort = {
  fieldName: 'deliveryDate',
  sortType: 'desc',
  viewBy: 'All',
};

const createDeliverySortReducer = createReducer(
  initialState,
  on(fromActions.setSort, (state: DeliverySort, deliverySort) => ({ ...state, ...deliverySort })),
  on(fromActions.setSortField, (state: DeliverySort, action: any) => (
    { ...state, fieldName: action.fieldName }
  )),
  on(fromActions.setSortType, (state: DeliverySort, action) => (
    { ...state, sortType: action.sortType }
  )),
  on(fromActions.resetSort, () => {
    const sortType: DeliverySortType = 'desc';
    const fieldName: DeliverySortField = 'deliveryDate';
    const viewBy: DeliverySortView = 'All';

    return {
      sortType,
      fieldName,
      viewBy,
    };
  }),
  on(fromActions.setUnread, (state: DeliverySort, data) => {
    const { viewBy } = data;
    return { ...state, viewBy };
  }),
);

export function deliverySortReducer(state: DeliverySort, action: Action) {
  return createDeliverySortReducer(state, action);
}

export const deliverySortKey = 'deliverySort';
